import React from 'react';

import { Block } from '../common/Block.jsx';
import { Column, Row, Spaced } from '../common/Container.jsx';
import { FormContainer } from '../common/Form.jsx';
import FormField from '../common/FormField.jsx';
import { Required, Text, Wrapper as InputWrapper } from '../common/Input.jsx';
import Layout from '../common/Layout.jsx';
import Name from '../common/Name.jsx';
import Token from '../common/Token.jsx';
import Utilities from '../common/Utilities.jsx';

import Defaults from '../layout/Defaults.jsx';
import Kit from '../layout/Kit.jsx';

// #region CARD FORM V1 (-- DEPRECATED Use `CardFormV2` --)

function CardFormV1Component(props) {
    const handleChange = (name, value) => {
        const data = props.data || {};
        data[name] = value;
        props.onChange(data);
    }
    const columnLeftStyle = { paddingRight: '10px' }
    const columnRightStyle = { paddingLeft: '10px' }
    const rowStyle = { marginBottom: '20px' }
    let inputStyle;
    if (props.blockConfig && props.blockConfig.block) {
        inputStyle = {};
        Block.mapStyleConfigProps(inputStyle, props.blockConfig.block, (propName, propValue, propUnit) => {
            switch (propName) {
                case 'columnSpacing':
                    if (propValue && propUnit) {
                        const value = (parseFloat(propValue) || 0) / 2.0;
                        columnLeftStyle.paddingRight = `${value}${propUnit}`;
                        columnRightStyle.paddingLeft = `${value}${propUnit}`;
                    }
                    return true;
                case 'rowSpacing':
                    if (propValue && propUnit) {
                        rowStyle.marginBottom = `${propValue}${propUnit}`;
                    }
                    return true;
            }
        });
    }
    let disabled = false;
    switch (props.state) {
        case 'processing':
        case 'success':
            disabled = true;
            break;
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props);
    if (props.builder || disabled) {
        layoutStyles.style.pointerEvents = 'none';
    }
    let className = 'form form--contact form--payment form--whitelabel__v1';
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    const data = props.data || {};
    let content = (
        <form ref={props.refSubmit} id="purchaseForm" className={className} style={layoutStyles.style} onSubmit={(e) => e && e.preventDefault()}>
            <Spaced>
                <Row style={rowStyle}>
                    <Column size="6" style={columnLeftStyle}>
                        <InputWrapper size="small">
                            <Required
                                autoComplete='given-name'
                                disabled={disabled}
                                name="FirstName"
                                placeholder="First Name *"
                                style={inputStyle}
                                type="text"
                                value={data.FirstName}
                                onChange={handleChange} />
                        </InputWrapper>
                    </Column>
                    <Column size="6" style={columnRightStyle}>
                        <InputWrapper size="small">
                            <Required
                                autoComplete='family-name'
                                disabled={disabled}
                                name="LastName"
                                placeholder="Last Name *"
                                style={inputStyle}
                                type="text"
                                value={data.LastName}
                                onChange={handleChange} />
                        </InputWrapper>
                    </Column>
                </Row>
                <Row style={rowStyle}>
                    <Column size="6" style={columnLeftStyle}>
                        <InputWrapper size="small">
                            <Required
                                autoComplete='email'
                                disabled={disabled}
                                name="Email"
                                placeholder="Email *"
                                style={inputStyle}
                                type="email"
                                value={data.Email}
                                onChange={handleChange} />
                        </InputWrapper>
                    </Column>
                    <Column size="6" style={columnRightStyle}>
                        <InputWrapper size="small">
                            <Required
                                autoComplete='tel'
                                disabled={disabled}
                                name="Phone"
                                placeholder="Phone *"
                                style={inputStyle}
                                type="tel"
                                value={data.Phone}
                                onChange={handleChange} />
                        </InputWrapper>
                    </Column>
                </Row>
                <Row style={rowStyle}>
                    <Column size="6" style={columnLeftStyle}>
                        <InputWrapper size="small">
                            <Required
                                autoComplete='address-line1'
                                disabled={disabled}
                                name="AddressLineOne"
                                placeholder="Address Line 1 *"
                                style={inputStyle}
                                type="text"
                                value={data.AddressLineOne}
                                onChange={handleChange} />
                        </InputWrapper>
                    </Column>
                    <Column size="6" style={columnRightStyle}>
                        <InputWrapper size="small">
                            <Text
                                autoComplete='address-line2'
                                disabled={disabled}
                                name="AddressLineTwo"
                                placeholder="Address Line 2"
                                style={inputStyle}
                                type="text"
                                value={data.AddressLineTwo}
                                onChange={handleChange} />
                        </InputWrapper>
                    </Column>
                </Row>
                <Row style={rowStyle}>
                    <Column size="6" style={columnLeftStyle}>
                        <InputWrapper size="small">
                            <Required
                                autoComplete='address-level2'
                                disabled={disabled}
                                name="City"
                                placeholder="City *"
                                style={inputStyle}
                                type="text"
                                value={data.City}
                                onChange={handleChange} />
                        </InputWrapper>
                    </Column>
                    <Column size="6" style={columnRightStyle}>
                        <InputWrapper size="small">
                            <Required
                                autoComplete='address-level1'
                                disabled={disabled}
                                name="State"
                                placeholder="State *"
                                style={inputStyle}
                                type="text"
                                value={data.State}
                                onChange={handleChange} />
                        </InputWrapper>
                    </Column>
                </Row>
                <Row style={rowStyle}>
                    <Column size="6" style={columnLeftStyle}>
                        <InputWrapper size="small">
                            <Required
                                autoComplete='postal-code'
                                disabled={disabled}
                                name="Zip"
                                placeholder="Zip *"
                                style={inputStyle}
                                type="text"
                                value={data.Zip}
                                onChange={handleChange} />
                        </InputWrapper>
                    </Column>
                    <Column size="6" style={columnRightStyle}>
                        <InputWrapper size="small">
                            <Required
                                autoComplete='country-name'
                                disabled={disabled}
                                name="Country"
                                placeholder="Country *"
                                style={inputStyle}
                                type="text"
                                value={data.Country}
                                onChange={handleChange} />
                        </InputWrapper>
                    </Column>
                </Row>
                <Row style={rowStyle}>
                    <Column size="12">
                        <InputWrapper size="small">
                            <Text
                                disabled={disabled}
                                name="Notes"
                                placeholder="Notes/Requests"
                                style={inputStyle}
                                type="text"
                                value={data.Notes}
                                onChange={handleChange} />
                        </InputWrapper>
                    </Column>
                </Row>
                <Row style={rowStyle}>
                    <Column size="12">
                        <InputWrapper size="small">
                            <Required
                                autoComplete='cc-number'
                                disabled={disabled}
                                maxLength="19"
                                name="PaymentAccount"
                                placeholder="Card Number *"
                                style={inputStyle}
                                type="text"
                                value={data.PaymentAccount}
                                onChange={handleChange} />
                        </InputWrapper>
                    </Column>
                </Row>
                <Row>
                    <Column size="6" style={columnLeftStyle}>
                        <InputWrapper size="small">
                            <Required
                                autoComplete='cc-exp'
                                disabled={disabled}
                                name="Expiration"
                                placeholder="Expiration Date (MM/YY) *"
                                style={inputStyle}
                                type="text"
                                value={data.Expiration}
                                onChange={handleChange} />
                        </InputWrapper>
                    </Column>
                    <Column size="6" style={columnRightStyle}>
                        <InputWrapper size="small">
                            <Required
                                autoComplete='cc-csc'
                                disabled={disabled}
                                name="CVC"
                                placeholder="CVC *"
                                style={inputStyle}
                                type="text"
                                value={data.CVC}
                                onChange={handleChange} />
                        </InputWrapper>
                    </Column>
                </Row>
            </Spaced>
            {
                props.error &&
                <div id="purchaseErrorContainer" style={{ marginTop: rowStyle.marginBottom }}>
                    <p className="error">{props.error}</p>
                </div>
            }
        </form>
    );
    if (layoutStyles.containerStyle) {
        if (props.inLayout) {
            layoutStyles.containerStyle.width = '100%';
        }
        content = <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>{content}</div>
    }
    return content;
}
const CardFormV1 = { Component: CardFormV1Component };

// #endregion CARD FORM V1

// #region CARD FORM V2

function CardFormV2Component(props) {
    const handleChange = (name, value) => {
        const data = props.data || {};
        data[name] = value;
        props.onChange(data);
    }
    const hasSameAddress = () => props.data && props.data[FormField[Name.Block.Cart.CardForm.Container].SameAddressCheckbox]
    const handleFormFieldProps = ({ type }, formFieldProps) => {
        switch (type) {
            case FormField.BillingAddress.AddressLine1:
                formFieldProps.autoComplete = 'address-line1';
                formFieldProps.hidden = hasSameAddress();
                formFieldProps.placeholderText = 'Billing Address Line 1 *';
                break;
            case FormField.BillingAddress.AddressLine2:
                formFieldProps.autoComplete = 'address-line2';
                formFieldProps.hidden = hasSameAddress();
                formFieldProps.placeholderText = 'Billing Address Line 2';
                formFieldProps.required = false;
                break;
            case FormField.BillingAddress.City:
                formFieldProps.autoComplete = 'address-level2';
                formFieldProps.hidden = hasSameAddress();
                formFieldProps.placeholderText = 'Billing City *';
                break;
            case FormField.BillingAddress.Country:
                formFieldProps.autoComplete = 'country-name';
                formFieldProps.hidden = hasSameAddress();
                formFieldProps.placeholderText = 'Billing Country *';
                break;
            case FormField.BillingAddress.State:
                formFieldProps.autoComplete = 'address-level1';
                formFieldProps.hidden = hasSameAddress();
                formFieldProps.placeholderText = 'Billing State *';
                break;
            case FormField.BillingAddress.Zip:
                formFieldProps.autoComplete = 'postal-code';
                formFieldProps.hidden = hasSameAddress();
                formFieldProps.placeholderText = 'Billing Zip *';
                break;
            case FormField.CardNumber:
                formFieldProps.autoComplete = 'cc-number';
                formFieldProps.hidden = !props.editor;
                formFieldProps.maxLength = '19';
                formFieldProps.placeholderText = 'Card Number *';
                break;
            case FormField.Email:
                formFieldProps.autoComplete = 'email';
                formFieldProps.placeholderText = 'Email Address *';
                formFieldProps.type = 'email';
                break;
            case FormField[Name.Block.Cart.CardForm.Container].ErrorMessage:
                formFieldProps.editor = props.editor;
                formFieldProps.error = props.error;
                break;
            case FormField.ExpirationDate:
                formFieldProps.autoComplete = 'cc-exp';
                formFieldProps.hidden = !props.editor;
                formFieldProps.placeholderText = 'Expiration Date (MM/YY) *';
                break;
            case FormField.FirstName:
                formFieldProps.autoComplete = 'given-name';
                formFieldProps.placeholderText = 'First Name *';
                break;
            case FormField.LastName:
                formFieldProps.autoComplete = 'family-name';
                formFieldProps.placeholderText = 'Last Name *';
                break;
            case FormField.Notes:
                formFieldProps.placeholderText = 'Notes/Requests';
                formFieldProps.required = false;
                break;
            case FormField.Phone:
                formFieldProps.autoComplete = 'tel';
                formFieldProps.placeholderText = 'Phone *';
                formFieldProps.type = 'tel';
                break;
            case FormField.SecurityCode:
                formFieldProps.autoComplete = 'cc-csc';
                formFieldProps.hidden = !props.editor;
                formFieldProps.placeholderText = 'CVC *';
                break;
            case FormField.ShippingAddress.AddressLine1:
                formFieldProps.autoComplete = 'address-line1';
                formFieldProps.placeholderText = 'Shipping Address Line 1 *';
                break;
            case FormField.ShippingAddress.AddressLine2:
                formFieldProps.autoComplete = 'address-line2';
                formFieldProps.placeholderText = 'Shipping Address Line 2';
                formFieldProps.required = false;
                break;
            case FormField.ShippingAddress.City:
                formFieldProps.autoComplete = 'address-level2';
                formFieldProps.placeholderText = 'Shipping City *';
                break;
            case FormField.ShippingAddress.Country:
                formFieldProps.autoComplete = 'country-name';
                formFieldProps.placeholderText = 'Shipping Country *';
                break;
            case FormField.ShippingAddress.State:
                formFieldProps.autoComplete = 'address-level1';
                formFieldProps.placeholderText = 'Shipping State *';
                break;
            case FormField.ShippingAddress.Zip:
                formFieldProps.autoComplete = 'postal-code';
                formFieldProps.placeholderText = 'Shipping Zip *';
                break;
        }
    }
    let contentConfig = props.contentConfig;
    if (!contentConfig) {
        if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.design && props.blockConfig.layout.design.desktop && props.blockConfig.layout.design.desktop.blocks && props.blockConfig.layout.design.desktop.blocks.length > 0) {
            contentConfig = props.blockConfig.layout.design;
        } else {
            contentConfig = Defaults.Block[Name.Block.Cart.CardForm.Container];
        }
    }
    let contentProps;
    if (!props.editor) {
        contentProps = {
            id: 'purchaseForm',
            ref: props.refSubmit,
            onSubmit: (e) => e && e.preventDefault()
        }
        if (Block.findBlockConfig((block) => block.type && block.type.value == Name.Block.Cart.StripeElements, contentConfig.desktop && contentConfig.desktop.blocks) == null) {
            const result = Block.findBlockConfig((block) => block.config && block.config.block && block.config.block.type == FormField.CardNumber, contentConfig.desktop && contentConfig.desktop.blocks);
            if (result && result.blocks) {
                const cardNumberBlockConfig = result.blocks[result.index];
                const stripeElements = Defaults.Block[Name.Block.Cart.StripeElements];
                if (cardNumberBlockConfig.config) {
                    let height;
                    for (let id in cardNumberBlockConfig.config.layout) {
                        switch (id) {
                            case 'alignment':
                            case 'width':
                                // Not supported
                                break;
                            case 'height':
                                height = cardNumberBlockConfig.config.layout[id];
                                break;
                            default:
                                const value = cardNumberBlockConfig.config.layout[id];
                                if (value != undefined && value.unit) {
                                    stripeElements.config.input[id] = { ...value };
                                } else {
                                    stripeElements.config.input[id] = value;
                                }
                                break;
                        }
                    }
                    for (let id in cardNumberBlockConfig.config.block) {
                        switch (id) {
                            case 'type':
                                // Not supported
                                break;
                            case 'placeholder':
                                const placeholder = cardNumberBlockConfig.config.block[id]
                                const typeStyle = Utilities.typeStyleFromString(placeholder) || Kit.Context.Global.Paragraph;
                                const style = Utilities.extractStyle(placeholder);
                                stripeElements.config.input[id] = Layout.wrapTextForEditor({ tag: typeStyle, text: `{${Token.PlaceholderText}}`, textExtras: style ? `style="${style}"` : undefined, token: Token.PlaceholderText })
                                break;
                            default:
                                const value = cardNumberBlockConfig.config.block[id];
                                if (value != undefined && value.unit) {
                                    stripeElements.config.input[id] = { ...value };
                                } else {
                                    stripeElements.config.input[id] = value;
                                }
                                break;
                        }
                    }
                    if (height && height.value && height.value.length > 0) {
                        stripeElements.config.input.paddingBottom = { value: '0', unit: 'px' };
                        stripeElements.config.input.paddingTop = { value: '0', unit: 'px' };

                        let heightValue = parseInt(height.value, 10);
                        if (!isNaN(heightValue)) {
                            if (stripeElements.config.input.borderTopWidth && stripeElements.config.input.borderTopWidth.value && stripeElements.config.input.borderTopWidth.value.length > 0) {
                                const borderWidth = parseInt(stripeElements.config.input.borderTopWidth.value, 10);
                                if (!isNaN(borderWidth)) {
                                    heightValue -= borderWidth;
                                }
                            }
                            if (stripeElements.config.input.borderBottomWidth && stripeElements.config.input.borderBottomWidth.value && stripeElements.config.input.borderBottomWidth.value.length > 0) {
                                const borderWidth = parseInt(stripeElements.config.input.borderBottomWidth.value, 10);
                                if (!isNaN(borderWidth)) {
                                    heightValue -= borderWidth;
                                }
                            }
                            stripeElements.config.input.design = Utilities.injectStyleIntoString(stripeElements.config.input.design, `line-height:${heightValue}${height.unit};`)
                        }
                    }
                    let gap = 0;
                    if (stripeElements.config.input.marginBottom && stripeElements.config.input.marginBottom.value && stripeElements.config.input.marginBottom.value.length > 0) {
                        const margin = parseInt(stripeElements.config.input.marginBottom.value, 10);
                        if (!isNaN(margin)) {
                            gap += margin;
                        }
                        stripeElements.config.input.marginBottom.value = '';
                    }
                    if (stripeElements.config.input.marginTop && stripeElements.config.input.marginTop.value && stripeElements.config.input.marginTop.value.length > 0) {
                        const margin = parseInt(stripeElements.config.input.marginTop.value, 10);
                        if (!isNaN(margin)) {
                            gap += margin;
                        }
                        stripeElements.config.input.marginTop.value = '';
                    }
                    if (gap > 0) {
                        stripeElements.config.input.gridRowSpacing = { value: `${gap}`, unit: 'px' };
                    }
                }
                result.blocks.splice(result.index, 0, stripeElements);
            }
        }
    }
    const handleBlockProps = (blockConfig) => {
        if (!blockConfig.type) {
            return;
        }
        switch (blockConfig.type.value) {
            case Name.Block.Cart.StripeElements:
                return { cartData: props.cartData, config: props.config, disabled: props.disabled, onParseConfig: props.onStripeElementsConfig };
        }
    }
    const formData = props.data || {};
    formData.formState = props.formState;
    return (
        <FormContainer.Component
            {...props}
            blockPropsHandler={handleBlockProps}
            contentConfig={contentConfig}
            contentProps={contentProps}
            formData={formData}
            onChange={handleChange}
            onFormFieldProps={handleFormFieldProps} />
    );
}
const CardFormV2 = { Component: CardFormV2Component };

// #endregion CARD FORM V2

export {
    CardFormV2,

    // DEPRECATED
    CardFormV1
}